module.exports = __webpack_public_path__ + "4cf2f8ad79945fa6fb6d4a2928e7eb1d.svg";